import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Full-page loading spinner used as a Suspense fallback
 * when lazy-loaded page components are being fetched.
 */
const PageLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-primary mx-auto mb-3" />
        <p className="text-sm text-gray-500">Loading...</p>
      </div>
    </div>
  );
};

export default PageLoader;
